import {
  CONTENT_TYPE,
  IInteractiveCardMini as IContentfulInteractiveCardMini,
} from 'marketing-site/@types/generated/contentful'
import { IProps as IInteractiveCardMini } from 'marketing-site/src/mvp/library/elements/InteractiveCardMini'
import { renderTransformedComponent } from 'marketing-site/lib/transformedComponents'

const transformImage = (image: IContentfulInteractiveCardMini['fields']['image']) => {
  if (!image) return
  const contentTypeId = image?.sys.contentType?.sys.id as CONTENT_TYPE
  return renderTransformedComponent(contentTypeId, image)
}

export function transformInteractiveCardMini({
  fields,
}: IContentfulInteractiveCardMini): IInteractiveCardMini {
  return {
    ...fields,
    title: fields.title,
    image: transformImage(fields.image),
  }
}
